import React, {useState, useEffect, useContext} from 'react';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import GlobalConstants from '../GlobalConstants';
import {
  Badge,
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import {Context as AuthContext} from '../../contexts/AuthContext';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import {styled, createTheme, ThemeProvider} from '@mui/material/styles';
import {prettifyMediumDate} from '../../api/dateManager';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import {getDashboardData} from '../../api/firebase';

const drawerWidth = 240;

const HomeDrawer = ({index, setIndex, product, orgCode, setOrgCode}) => {
  const navigate = useNavigate();
  const {
    state: {uid, universal, client, financial},
    logout,
  } = useContext(AuthContext);

  const [open, setOpen] = useState(true);
  const [show, setShow] = useState(false);

  const lastRefresh = null;
  const products = ['dashboard', 'pfm'];
  const headers = [
    'Dashboard',
    'Financial',
    'At Risk',
    'Profile',
    'Goals',
    'Notifications',
  ];
  const navTextStyle = {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '24px',
    color: '#41415a',
  };

  useEffect(() => {
    // getProfiles();
    // getAtRisk();
  }, []);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  // FUNCTION THAT DOWNLOAD OUR STUDENT FLIER
  const downloadFlier = () => {
    // using Java Script method to get PDF file
    fetch('FinSiteful-Flyer.pdf').then(response => {
      response.blob().then(blob => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'FinSiteful-Flyer.pdf';
        alink.click();
      });
    });
  };

  const DashboardPanel = ({settings, show, setShow}) => {
    if (!settings || !settings.active) {
      return null;
    }

    const orgCodes = [
      {name: 'Fake', code: 'fake'},
      {name: 'CPCC', code: 'cpcc23810674'},
      {name: 'BCCC', code: 'bccc53028742'},
      {name: 'MCC', code: 'mcc46901327'},
    ];

    return (
      <>
        {universal.dashboard.role === 'owner' && (
          <>
            <ListSubheader component="div" inset>
              <Typography
                onClick={() => {
                  setShow(!show);
                }}
                sx={{fontWeight: 'bold'}}>
                Organization
              </Typography>
            </ListSubheader>
            {show &&
              orgCodes.map(({name, code}, i) => (
                <ListItemButton
                  key={i}
                  sx={[{background: orgCode === code ? '#ADD8E6' : null}]}
                  onClick={() => {
                    setOrgCode(code);
                  }}>
                  <ListItemText
                    primary={
                      <Typography style={navTextStyle}>{name}</Typography>
                    }
                  />
                </ListItemButton>
              ))}
            <Divider sx={{my: 1}} />
          </>
        )}
        <ListSubheader component="div" inset>
          <Typography sx={{fontWeight: 'bold'}}>Client</Typography>
        </ListSubheader>
        <ListItemButton
          sx={{
            background:
              product === 'dashboard' && index === 0 ? '#ADD8E6' : null,
          }}
          onClick={() => {
            if (product !== 'dashboard') {
              navigate('/dashboard', {state: {index: 0}});
            }
            setIndex(0);
          }}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={navTextStyle}>{headers[0]}</Typography>}
          />
        </ListItemButton>
        <ListItemButton
          sx={[
            {
              background:
                product === 'dashboard' && index === 1 ? '#ADD8E6' : null,
            },
          ]}
          onClick={() => {
            if (product !== 'dashboard') {
              navigate('/dashboard', {state: {index: 1}});
            }
            setIndex(1);
          }}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={navTextStyle}>{headers[1]}</Typography>}
          />
        </ListItemButton>
        <ListItemButton
          sx={[
            {
              background:
                product === 'dashboard' && index === 2 ? '#ADD8E6' : null,
            },
          ]}
          onClick={() => {
            if (product !== 'dashboard') {
              navigate('/dashboard', {state: {index: 2}});
            }
            setIndex(2);
          }}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={navTextStyle}>{headers[2]}</Typography>}
          />
        </ListItemButton>
        {open && (
          <ListItemButton
            onClick={() => {
              downloadFlier();
            }}>
            <ListItemText
              primary={
                <Typography style={navTextStyle}>{'Download Flier'}</Typography>
              }
            />
          </ListItemButton>
        )}
        <Divider sx={{my: 1}} />
      </>
    );
  };

  const PFMPanel = ({settings}) => {
    if (!settings || !settings.active) {
      return null;
    }
    return (
      <>
        <ListSubheader component="div" inset>
          <Typography sx={{fontWeight: 'bold'}}>Users</Typography>
        </ListSubheader>

        <ListItemButton
          sx={{background: product === 'pfm' && index === 3 ? '#ADD8E6' : null}}
          onClick={() => {
            if (product !== 'pfm') {
              navigate('/pfm', {state: {index: 3}});
            }
            setIndex(3);
          }}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={navTextStyle}>{headers[3]}</Typography>}
          />
        </ListItemButton>
        <ListItemButton
          sx={[
            {background: product === 'pfm' && index === 4 ? '#ADD8E6' : null},
          ]}
          onClick={() => {
            if (product !== 'pfm') {
              navigate('/pfm', {state: {index: 4}});
            }
            setIndex(4);
          }}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={navTextStyle}>{headers[4]}</Typography>}
          />
        </ListItemButton>
        <Divider sx={{my: 1}} />
      </>
    );
  };

  return (
    <>
      <AppBar
        position="absolute"
        open={open}
        sx={{
          background: 'transparent',
          boxShadow: 'none',
          color: '#9d9db0',
        }}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: '36px',
              marginBottom: '24px',
              ...(open && {display: 'none'}),
            }}>
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{
              flexGrow: 1,
              fontSize: '15px',
              textTransform: 'uppercase',
              padding: '35px 35px',
            }}>
            {headers[index]}
          </Typography>
          {/* <TextField
              style={{width: 500, alignSelf: 'center'}}
              id="outlined-basic"
              label="Search for students"
              variant="outlined"
            /> */}
          {lastRefresh && (
            <Typography variant="p" sx={{fontSize: 14}}>
              last updated {prettifyMediumDate(lastRefresh)}
            </Typography>
          )}
          <IconButton
            color="inherit"
            onClick={() => {
              if (product !== 'notifications') {
                navigate('/notifications');
              }
              setIndex(5);
            }}>
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: [1],
          }}>
          <IconButton
            onClick={toggleDrawer}
            sx={{
              ...(!open && {display: 'none'}),
            }}>
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <List component="nav">
          <React.Fragment>
            {products.map((product, i) => {
              const settings = universal ? universal[product] : null;
              switch (product) {
                case 'dashboard':
                  return (
                    <DashboardPanel
                      key={i}
                      settings={settings}
                      show={show}
                      setShow={setShow}
                    />
                  );

                case 'pfm':
                  return <PFMPanel key={i} settings={settings} />;

                default:
                  return null;
              }
            })}

            <ListItemButton
              sx={[{background: index === -1 ? '#ADD8E6' : null}]}
              onClick={() => {
                const success = logout();
                if (success) {
                  navigate('/');
                }
              }}>
              <ListItemText
                primary={
                  <Typography style={navTextStyle}>{'Logout'}</Typography>
                }
              />
            </ListItemButton>
            {/* <ListItemButton
              sx={[{background: index === -1 ? '#ADD8E6' : null}]}
              onClick={async () => {
                try {
                  // boot();
                  // show();
                } catch (err) {
                  console.log('ERR', err);
                }
              }}>
              <ListItemText
                primary={
                  <Typography style={navTextStyle}>{'TESTING'}</Typography>
                }
              />
            </ListItemButton> */}
          </React.Fragment>
        </List>
      </Drawer>
    </>
  );
};

export default HomeDrawer;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})(({theme, open}) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {shouldForwardProp: prop => prop !== 'open'})(
  ({theme, open}) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);
